import { error, money } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const FeeBasedTransferRouteDetailsQuery = gql`
  query FeeBasedTransferRouteDetails($input: TransferRouteDetailsInput!) {
    transferRouteDetails(input: $input) {
      __typename
      ... on TransferRouteDetails {
        transferSpeed {
          speedDescription
          icon
        }
        feeInfo {
          feePercentageText
          feeRate
          maximumPrincipalAmount {
            ...money
          }
          minimumPrincipalAmount {
            ...money
          }
          minimumPrincipalMessage
          maximumPrincipalMessage
          limitErrorMessage
        }
      }
      ... on TransferNotPossibleError {
        ...error
      }
    }
  }
  ${error}
  ${money}
`;

export default FeeBasedTransferRouteDetailsQuery;
